export default {"src":"/_next/static/media/shipping.71894f15.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};